import React, { Component, PropTypes } from 'react';
import classNames from 'classnames';
import { Units, Colors, Shadow, hexToRgba } from 'Css';

const css = oxygenCss({
  root: {
    position: 'relative',
    minHeight: '48px',
    boxSizing: 'border-box',
    userSelect: 'none',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'flex-start',
    justifyItems: 'center',
    '&padded': {
      padding: `${Units.base}px 40px`
    },
    '&responsive': {
      '@phone': {
        flexDirection: 'column',
        padding: Units.base / 2
      }
    },
    '&divider': {
      borderStyle: 'none none solid none',
      borderWidth: 1,
      borderColor: Colors.text.Dark.divider
    },
    '&card': {
      margin: Units.base,
      boxShadow: Shadow[1],
      backgroundColor: Colors.theme.Light.card,
      '@phone': {
        margin: Units.base / 2
      }
    },
    '&selected': {
      backgroundColor: `${hexToRgba(Colors.material.coursio[300].hex, 25)}`
    },
    ':hover': {
      backgroundColor: `${hexToRgba(Colors.material.coursio[300].hex, 5)}`,
      '&selected': {
        backgroundColor: `${hexToRgba(Colors.material.coursio[300].hex, 25)}`
      }
    }
  }
});

class ListItem extends Component {
  static propTypes = {
    children: PropTypes.node,
    payload: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.string,
      PropTypes.bool,
      PropTypes.number,
      PropTypes.array
    ]),
    selected: PropTypes.bool,
    divider: PropTypes.bool,
    card: PropTypes.bool,
    padded: PropTypes.bool,
    onTouchTap: PropTypes.func,
    responsive: PropTypes.bool
  };

  static defaultProps = {
    padded: true
  };

  handleTouchTap = () => {
    const { payload, onTouchTap } = this.props;
    onTouchTap && onTouchTap(payload);
  };

  render() {
    const {
      children,
      divider,
      responsive,
      selected,
      card,
      padded,
      ...other
    } = this.props;
    const classes = classNames(css.root, {
      [css.padded]: padded,
      [css.selected]: selected,
      [css.divider]: divider,
      [css.card]: card,
      [css.responsive]: responsive
    });
    return (
      <div className={classes} {...other} onTouchTap={this.handleTouchTap}>
        {children}
      </div>
    );
  }
}

export default ListItem;



// WEBPACK FOOTER //
// ./src/js/components/List/ListItem.js